import React from 'react';
import { Countdown } from './Countdown';
const CLAIMED_PERCENT = 68;
export function LaunchUrgency() {
  return <section aria-labelledby="urgency-heading" className="bg-wood-dark py-12 sm:py-20" data-id="element-137" data-mp="mfwwmerhwptg">
      <div className="mx-auto grid max-w-shell gap-10 px-5 sm:px-6 lg:grid-cols-2 lg:items-center lg:gap-20" data-id="element-138" data-mp="11645c2rpaugy">
        <div data-id="element-139" data-mp="w7supptl0fxo">
          <p className="text-[10px] font-semibold uppercase tracking-label text-gold sm:text-[11px]" data-id="element-140" data-mp="w79o359dtdyy">
            Limited-time offer
          </p>
          <h2 id="urgency-heading" className="mt-4 font-display text-2xl leading-tight text-paper sm:text-4xl" data-id="element-141" data-mp="3ic50zxcjd55">
            Launch pricing expires in
          </h2>
          <div className="mt-6" data-id="element-142" data-mp="dgi5dd3i8b7w">
            <Countdown initialSeconds={86347} tone="light" data-id="element-143" data-mp="df7018ueuveo" />
          </div>
          <p className="mt-6 max-w-md text-sm text-paper-400" data-id="element-144" data-mp="1swh98c639l2c">
            Launch pricing ends today. After that, pricing returns to $97.
          </p>
        </div>

        <div className="border border-wood-light bg-noir-800 p-5 sm:p-7" data-id="element-145" data-mp="1oxro1xet6z85">
          <div className="flex items-baseline justify-between gap-4" data-id="element-146" data-mp="1yi531vcc8jio">
            <span className="text-[10px] font-semibold uppercase tracking-label text-paper-400 sm:text-[11px]" data-id="element-147" data-mp="23gyhbpzg8ejw">
              Limited availability &mdash; today only
            </span>
            <span className="font-display text-2xl font-semibold leading-none text-gold" data-id="element-148" data-mp="2ciy12q1ulwqj">
              {CLAIMED_PERCENT}%
            </span>
          </div>
          <div className="mt-5 h-2 w-full bg-wood" role="progressbar" aria-valuenow={CLAIMED_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Launch allocation claimed" data-id="element-149" data-mp="1fq2l8gnymx6u">
            <div className="h-full bg-gold" style={{
            width: `${CLAIMED_PERCENT}%`
          }} data-id="element-150" data-mp="1tklpkxngsars" />
          </div>
          <p className="mt-4 text-xs uppercase tracking-label text-paper-400" data-id="element-151" data-mp="w3eodygk2e69">Claimed</p>
        </div>
      </div>
    </section>;
}